import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export enum CompanyGovernmentAllocationStatus {
  pending = 'pending',
  active = 'active',
  paused = 'Pausado',
}

export const companyGovernmentAllocationStatusOptions = [
  { value: CompanyGovernmentAllocationStatus.pending, label: 'Pendente' },
  { value: CompanyGovernmentAllocationStatus.active, label: 'Ativo' },
  { value: CompanyGovernmentAllocationStatus.paused, label: 'Pausado' },
]

export const companyGovernmentAllocationStatusStrategy = optionsToStrategy(companyGovernmentAllocationStatusOptions)
